import { PortalEntity, PortalTenantSetting, SecurityRoleTiny, TenantInfoRequest, TenantSetting, TenantUser } from '@jms/model';

export interface ApplicationSettings {
    applicationName: string;
    applicationDescription: string;
    logo: string;
    banner: string;
}


export enum ApplicationActionName {
    AuthenticateLoginUser = '[Application] Authenticate Login User',
    AuthenticateLoginUserError = '[Application] Authenticate Login User Error',
    HandleInvalidUser = '[Application] Handle Invalid User',
    HandleValidUser = '[Application] Handle Valid User',
    GetPortalEntities = '[Application] Get Portal Entities',
    GetPortalEntitiesSuccess = '[Application] Get Portal Entities Success',
    GetPortalEntitiesFail = '[Application] Get Portal Entities Fail',
    ToggleNav = '[Application] Toggle Nav',
    LoginError = '[Application] Login Error',
    LogOut = '[Application] Logout',
    ChangePortalEntity = '[Application] Change Portal Entity',
    ChangePortalEntitySuccess = '[Application] Change Portal Entity Success',
    ChangePortalEntityFail = '[Application] Change Portal Entity Fail',
    GetTenantSettings = '[Application] Get Tenant Settings',
    GetTenantSettingsSuccess = '[Application] Get Tenant Settings Success',
    GetTenantSettingsFail = '[Application] Get Tenant Settings Fail'
}

export interface SocialUser {
    idToken: string;
    accessToken: string;
    image: string;
    profile: any;
    provider: string;
    sub: string;
}

export interface ApplicationPermission {
    newJob: boolean;
    newQuote: boolean;
}

export interface ApplicationState {
    navExpanded: boolean;
    token: string;
    tenantRole: SecurityRoleTiny;
    activeRole: SecurityRoleTiny;
    roles: SecurityRoleTiny[];
    user: TenantUser;
    settings: ApplicationSettings;
    route: any;
    returnUrl: string;
    domain: string;
    entities: PortalEntity[];
    selectedEntity: PortalEntity;
    info: TenantInfoRequest;
    tenantSettings: PortalTenantSetting[];
    selectedTenantSetting: PortalTenantSetting;
    /** Tenancies left out of the current sign-in because they are in maintenance mode; announced once the shell loads. */
    maintenanceTenants: string[];
}


